import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import usePointagePermissions from '../hooks/usePointagePermissions';
import CarnetPointageManuel from '../components/AttendanceTracking';

/**
 * Composant de routage intelligent pour le pointage
 * - Si l'utilisateur a UNIQUEMENT POINTAGES.KIOSK.VIEW → Redirige vers /kiosque-pointage
 * - Sinon → Affiche CarnetPointageManuel
 */
const PointageRouter = () => {
  const navigate = useNavigate();
  const { hasKioskOnly, hasAdminAccess, loading } = usePointagePermissions();
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    if (!loading) {
      if (hasKioskOnly) {
        // Utilisateur a UNIQUEMENT accès au kiosque
        console.log('🔀 Redirection vers kiosque (permission kiosque uniquement)');
        setRedirecting(true);
        
        // Redirection vers kiosque
        setTimeout(() => {
          navigate('/kiosque-pointage');
        }, 500);
      }
      // Sinon, on reste sur cette page et on affiche CarnetPointageManuel
    }
  }, [loading, hasKioskOnly, navigate]);

  // Écran de chargement
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin w-12 h-12 border-4 border-[#246990] border-t-transparent rounded-full mx-auto mb-4"></div>
          <p className="text-gray-600">Vérification des permissions...</p>
        </div>
      </div>
    );
  }

  // Écran de redirection
  if (redirecting) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-[#246990]/5 to-[#246990]/10">
        <div className="text-center bg-white p-8 rounded-2xl shadow-xl">
          <div className="animate-spin w-12 h-12 border-4 border-[#246990] border-t-transparent rounded-full mx-auto mb-4"></div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">Redirection vers le kiosque</h3>
          <p className="text-gray-600">Vous allez être redirigé vers l'interface de pointage...</p>
        </div>
      </div>
    );
  }

  // Afficher le carnet de pointage manuel (pour admins)
  return <CarnetPointageManuel />;
};

export default PointageRouter;